<template>
    <div>
        <div class="card-header bg-secondary">
            Écritures non importées - {{ titleTable }}
        </div>
        <div class="card-body">
            <div v-if="!hasLog">
                <b-alert show variant="secondary"
                    >Veuillez sélectionner les écritures non importées d'une mise à jour
                </b-alert>
            </div>
            <div v-else>
                <div class="d-flex justify-content-end">
                    <b-input-group class="col-6">
                        <b-form-input
                            id="filter-input"
                            v-model="search"
                            type="search"
                            placeholder="Recherche dans les écritures non importées..."
                        ></b-form-input>

                        <b-input-group-append>
                            <b-button :disabled="!search" @click="search = ''"
                                >Effacer
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <b-table
                    class="mt-3"
                    striped
                    foot-clone
                    :filter="search"
                    foot-variant="dark"
                    :items="updateLogs"
                    :fields="fields"
                >
                    <template #foot(account)="">
                        <span class="font-weight-bold">Total des écritures non importées</span>
                    </template>
                    <template #foot(description)="">
                        <span class="font-weight-bold"></span>
                    </template>
                    <template #foot(entry_piece)="">
                        <span class="font-weight-bold"></span>
                    </template>
                    <template #foot(reason)="">
                        <span class="font-weight-bold"></span>
                    </template>
                    <template #foot(amount)="">
                        <span class="font-weight-bold"
                            >{{ totalAmount }} €</span
                        >
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorLogsTable',

    props: {
        titleTable: {
            required: true,
            type: String,
        },
        hasLog: {
            required: true,
            type: Boolean,
        },
        updateLogs: {
            required: true,
            type: Array,
        },
        totalAmount: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            search: null,
            fields: [
                {
                    key: 'account',
                    label: 'Compte',
                    sortable: true,
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                },
                {
                    key: 'entry_piece',
                    label: 'Pièce',
                    sortable: true,
                },
                {
                    key: 'reason',
                    label: 'Motif',
                },
                {
                    key: 'amount',
                    label: 'Montant',
                    class: 'text-right',
                    sortable: true,
                },
            ],
        }
    },
}
</script>

<style scoped></style>
